import apiClient from '../../../common/services/apiClient';

export const apiCallIds = {
  NEW_INVESTMENT_OPPORTUNITIES_SIGNOUT: 'FETCH_SETTING',
  SIGNOUT: 'FETCH_SETTING',
};

export default {
  newInvestmentOpportunitiesSignout: token => {
    return apiClient.put(`/setting/signout/investment-opportunities/${token}`, {
      apiCallId: apiCallIds.NEW_INVESTMENT_OPPORTUNITIES_SIGNOUT,
    });
  },

  notificationSignOut: (token, mailName, email) => {
    let endpointURL = `/setting/signout/${token}/${mailName}`;
    if (email) {
      endpointURL = endpointURL + `?email=${email}`
    }
    return apiClient.put(endpointURL, {
      apiCallId: apiCallIds.SIGNOUT,
    });
  }
};



// WEBPACK FOOTER //
// ./src/features/signout-notifications/api/index.js